(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hpp-help-center"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hpp-help-center')){
class HPPHelpCenter extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const search=this.querySelector('[data-help-search]');const input=this.querySelector('input[type="search"]');const clear=this.querySelector('[data-help-clear]');const status=this.querySelector('[data-help-status]');const empty=this.querySelector('[data-help-empty]');const topics=[...this.querySelectorAll('[data-help-topic]')];const faqs=[...this.querySelectorAll('[data-help-faq]')];
if(!input)return;search.hidden=false;clear.hidden=true;
const apply=()=>{const query=input.value.trim().toLocaleLowerCase();const words=query.split(/\s+/).filter(Boolean);let count=0;
faqs.forEach(faq=>{const text=(faq.textContent+' '+faq.dataset.keywords).toLocaleLowerCase();const match=words.every(word=>text.includes(word));faq.hidden=!match;faq.open=Boolean(query)&&match;if(match)count++;});
topics.forEach(topic=>{topic.hidden=![...topic.querySelectorAll('[data-help-faq]')].some(faq=>!faq.hidden);});empty.hidden=count>0;clear.hidden=!query;status.textContent=query?this.dataset.countLabel.replace('{count}',String(count)):'';
};
input.addEventListener('input',apply);clear.addEventListener('click',()=>{input.value='';apply();input.focus();});
this.querySelectorAll('.hpp-help__nav a').forEach(link=>link.addEventListener('click',()=>{if(input.value){input.value='';apply();}}));
}
}
customElements.define('hpp-help-center',HPPHelpCenter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
